import { apm, init as initApm } from '@elastic/apm-rum'
import { Environment, HubConfig, MySquid, User, onLangChange, onUserChange } from '@hub/shared'
import { useEffect } from 'react'
import { Navigate } from 'react-router'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { SubscriptionLike } from 'rxjs'
import i18n from './i18n.mediakit'
import DetailMediaKitPage from './pages/detail-mediakit/detail-mediakit.page'
import ListMediaKitPage from './pages/list-mediakit/list-mediakit.page'
interface UserObject {
  id?: string | number
  username?: string
  email?: string
}

export default function Root(props: {
  configs: MySquid
  environments: Environment
  general: HubConfig
  mountParcel: any
  name: string
  singleSpa: any
  domElement: Element
  mainRoutes: string[]
}) {
  useEffect(() => {
    const onLangChangeObservable: SubscriptionLike = onLangChange.subscribe((lang: 'pt' | 'en' | 'es') => {
      i18n.changeLanguage(lang)
    })
    return () => {
      onLangChangeObservable?.unsubscribe()
    }
  }, [])

  useEffect(() => {
    initApm({
      environment: props?.environments?.env,
      serviceName: 'web-hub-midiakit',
      serverUrl: props?.environments?.apmUrl,
    })
    const onUserChangeObservable: SubscriptionLike = onUserChange.subscribe(async (userChanged: User) => {
      const userContext: UserObject = {
        id: userChanged?.squidId,
        username: userChanged?.profileadditionalinfo?.name,
        email: userChanged?.profileadditionalinfo?.email,
      }
      apm.setUserContext(userContext)
    })
    return () => {
      onUserChangeObservable?.unsubscribe()
    }
  }, [props.environments])

  const NoMatch = () => {
    history.pushState({}, '', '/error/not-found')
    return <div />
  }

  if (props?.configs?._id) {
    return (
      <Router>
        <Routes>
          <Route element={<Navigate to={{ pathname: '/error/not-found' }} />} />
        </Routes>
      </Router>
    )
  }

  if (props?.general?.maintenance) {
    history.pushState({}, '', '/error/maintenance')
    return <div />
  }

  return (
    <Router>
      <Routes>
        <Route path="mediakit" element={<ListMediaKitPage {...props} />} />
        <Route path="mediakit/:idProfile/*" element={<DetailMediaKitPage {...props} />} />
        {props?.mainRoutes?.map((r) => {
          return <Route path={`${r}/*`} key={r} />
        })}
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </Router>
  )
}
